import { useApolloClient } from '@apollo/react-hooks'
import { GET_DATA } from '@components/Modal/SingleProfileModal/QuerySingleProfile'
import React from 'react'
import { StudentProfileInfo } from '@interfaces/Student'

const useStudentQuery = (id: string) => {
  const [loading, setLoading] = React.useState(true)
  const [data, setData] = React.useState<StudentProfileInfo>()
  const client = useApolloClient()

  React.useEffect(() => {
    const getStudent = async (id: string) => {
      setLoading(true)
      const params = {
        StudentId: id,
      }

      const res = await client.query<any>({
        query: GET_DATA,
        variables: params,
        fetchPolicy: 'network-only',
      })

      setLoading(false)
      const studentProfileInfo = (res.data?.getStudents?.[0]?.StudentProfileInfo ?? {}) as StudentProfileInfo
      setData(studentProfileInfo)
    }

    if (!id) {
      setLoading(false)
    } else {
      getStudent(id)
    }
  }, [client, id])

  return { loading, data }
}

export default useStudentQuery
